import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap';
import { AiFillDelete, AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai';
import Api from '../../Api/Api';


function Cart({ totalQuantity, data, getCart }) {
  const [first, setFirst] = useState(true)
  const [address, setAddress] = useState(false)
  const [loading, setLoading] = useState(false)




  const handleFirst = () => {
    setFirst(false)
    setAddress(true)
  }
  const handleAddress = () => {
    setFirst(true)
    setAddress(false)
  }

  const plusCart = async (pid, quantity) => {
    try {
      setLoading(pid)
      const data = await Api.cartQuantity(pid, quantity + 1);
      console.log("dataaaaaaaaaa", data);
    } catch (e) {
      console.log(e);
    }
    getCart()
    setLoading(false)
  }
  const minusCart = async (pid, quantity) => {
    try {
      setLoading(pid)
      const data = await Api.cartQuantity(pid, quantity - 1);
      console.log("dataaaaaaaaaa", data);
    } catch (e) {
      console.log(e);
    }
    getCart()
    setLoading(false)
  }
  const removeCart = async (pid) => {
    try {
      setLoading(pid)
      const data = await Api.cartRemove(pid);
      console.log("dataaaaaaaaaa", data);
    } catch (e) {
      console.log(e);
    }
    getCart()
    setLoading(false)
  }


  return (
    <div className="offcanvas offcanvas-end" tabindex="-2" id="cart" aria-labelledby="cart">
      <div className="offcanvas-header">
        <h5 id="offcanvasRightLabel"><b>{first && "My Cart"}{address && "Add Address"}</b></h5>
        <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div className="offcanvas-body">
        {first && <>
          <div className="row" style={{ height: "80%", overflowY: "scroll" }}>
            {data?.products && data?.products?.map((item, index) => (
              <div key={index} className="d-flex row mb-3" style={{ maxHeight: "10rem", overflow: "hidden" }}>
                <div className="col-4">
                  <img
                    height={130}
                    width={110}
                    alt="product"
                    src={item?.pid?.image}
                  />
                </div>
                <div className="col-6">
                  <h5><b>{item?.pid?.title}</b></h5>
                  <h5><b>₹ {item?.pid?.sale_price || item?.pid?.price}</b></h5>
                  <b className="d-flex">
                    <div style={(loading && loading === item?.pid?._id) ? { pointerEvents: "none", opacity: "0.4" } : {}} type="button" className="p-2">
                      <AiOutlinePlus onClick={() => plusCart(item?.pid?._id, item?.quantity)} size="1.2rem" />
                    </div>
                    <div className="p-2">
                      {item?.quantity}
                    </div>
                    <div style={(loading && loading === item?.pid?._id) ? { pointerEvents: "none", opacity: "0.4" } : {}} type="button" className="p-2">
                      <AiOutlineMinus onClick={() => minusCart(item?.pid?._id, item?.quantity)} size="1.2rem" />
                    </div>
                  </b>
                </div>
                <div style={(loading && loading === item?.pid?._id) ? { pointerEvents: "none", opacity: "0.4" } : {}} type="button" className="col-2">
                  <AiFillDelete onClick={() => removeCart(item?.pid?._id)} size="1.5rem" />
                </div>
              </div>
            ))}
          </div>
          <div className="" style={{ height: "10%" }}>
            <h5 className="d-flex justify-content-between mx-2">
              <b>
                Cart Total Items
              </b>
              <b>
                {totalQuantity && totalQuantity}
              </b>
            </h5>
            <h5 className="d-flex justify-content-between mx-2">
              <b>
                Cart Total Price
              </b>
              <b>
                ₹ {data?.cart_total_price}
              </b>
            </h5>
            <div className="text-center">
              <button className="btn btn-dark w-100 h5" onClick={handleFirst} style={{ borderRadius: "1rem" }}><b>Proceed to Checkout</b></button>
            </div>
          </div>
        </>}

        {address && <>
          <div>
            {/* <Form> */}
            <div className="form-floating mb-3">
              <input className='mb-3 form-control form-control' id="floatingInput" type="text" placeholder="Last Name" />
              <label for="floatingInput">First Name</label>

            </div>
            <div className="form-floating mb-3">
              <input className='mb-3 form-control' type="text" placeholder="Last Name" />
              <label for="last">Last Name</label>
            </div>
            <div className="form-floating mb-3">
              <input className='mb-3 form-control' type="text" placeholder="Company Name" />
              <label for="company">Company Name</label>
            </div>
            <div className="form-floating mb-3">
              <input className='mb-3 form-control' type="email" placeholder="Your Email" />
              <label for="email">Your Email</label>
            </div>
            <div className="form-floating mb-3">
              <input className='mb-3 form-control' type="text" placeholder="Order Note" />
              <label for="floatingInput">Order Note</label>
            </div>
            <div className='d-flex mb-3'>
              <div className="form-floating me-3">
                <input className='form-control' type="text" placeholder="Mobile Number" />
                <label for="floatingInput">Mobile Number</label>
              </div>
              <div className="form-floating mb-3">
                <input className='form-control' type="text" placeholder="Pin Code" />
                <label for="floatingInput">Pin Code</label>
              </div>
            </div>
            <div className="form-floating mb-3">
              <input className='mb-3 form-control' type="text" placeholder="Flat, House No, Building, Company" />
              <label for="floatingInput">Flat, House No, Building, Company</label>
            </div>
            <div className="form-floating mb-3">
              <input className='mb-3 form-control' type="text" placeholder="Area, Street, Village" />
              <label for="floatingInput">Area, Street, Village</label>
            </div>
            <div className="form-floating mb-3">
              <input className='mb-3 form-control' type="text" placeholder="Town / City" />
              <label for="floatingInput">Town / City</label>
            </div>
            <div className='d-flex mb-3'>
              <div className="form-floating me-2">
                <input className='form-control' type="text" placeholder="State" />
                <label for="floatingInput">State</label>
              </div>
              <div className="form-floating">
                <input className='form-control' type="text" placeholder="Country" />
                <label for="floatingInput">Country</label>
              </div>
            </div>
            <div className="text-center">
              <button className="btn btn-dark w-100 h5" onClick={handleAddress} style={{ borderRadius: "1rem" }}><b>Place Order</b></button>
            </div>
            {/* </Form> */}
          </div>
        </>}

      </div>
    </div>
  )
}

export default Cart